import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { tap, filter, first } from 'rxjs/operators';
import * as selector from '../selectors';
import * as actions from '../actions';

@Injectable({
  providedIn: 'root'
})
export class MarketingResolver  {
  constructor(private store: Store) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | any {
    return this.store.select(selector.getMarketingLoaded).pipe(
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(actions.loadGetMarketingOptions());
        }
      }),
      filter(loaded => !!loaded),
      first()
    );
  }
}
